var _style, _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterUpIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.09449 60.09449",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n    * {\n      stroke-width: 0px;\n    }\n  ")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8.14632,
    y: 9.12145,
    width: 43.86898,
    height: 43.86898,
    rx: 10.01575,
    ry: 10.01575,
    transform: "translate(-13.1494 30.36642) rotate(-45)",
    strokeWidth: 0,
    fill: "#1d1d1b"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9.72245,
    y: 8.39395,
    width: 40.66394,
    height: 40.66394,
    rx: 10.01575,
    ry: 10.01575,
    transform: "translate(-11.50956 29.66531) rotate(-45)",
    strokeWidth: 0,
    fill: "#f59e00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.56851,18.92976h-2.30362l-1.40221-1.4022c-.50079-.50079-1.20189-.50079-1.70268,0l-1.40221,1.4022h-20.43213c-1.10173,0-2.00315.90142-2.00315,2.00315s.90142,2.00315,2.00315,2.00315h20.43213l1.40221,1.4022c.50079.50079,1.20189.50079,1.70268,0l1.40221-1.4022h2.30362c1.10173,0,2.00315-.90142,2.00315-2.00315s-.90142-2.00315-2.00315-2.00315Z",
    strokeWidth: 0,
    fill: "#82368c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.56851,27.34299h-8.61354l-1.40221-1.4022c-.50079-.50079-1.20189-.50079-1.70268,0l-1.4022,1.4022h-14.22236c-1.10173,0-2.00315.90142-2.00315,2.00315s.90142,2.00315,2.00315,2.00315h14.22236l1.4022,1.40221c.50079.50079,1.20189.50079,1.70268,0l1.40221-1.4022h8.61354c1.10173,0,2.00315-.90142,2.00315-2.00315s-.90142-2.00315-2.00315-2.00315Z",
    strokeWidth: 0,
    fill: "#82368c"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.56851,35.75622h-4.90772l-1.40221-1.40221c-.50079-.50079-1.20189-.50079-1.70268,0l-1.40221,1.40221h-17.92819c-1.10173,0-2.00315.90142-2.00315,2.00315s.90142,2.00315,2.00315,2.00315h17.92819l1.40221,1.40221c.50079.50079,1.20189.50079,1.70268,0l1.40221-1.40221h4.90772c1.10173,0,2.00315-.90142,2.00315-2.00315s-.90142-2.00315-2.00315-2.00315Z",
    strokeWidth: 0,
    fill: "#82368c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterUpIcon);
export default __webpack_public_path__ + "static/media/FilterUpIcon.9567bb5c281b93a6dd66ad612053e484.svg";
export { ForwardRef as ReactComponent };